import React, { useState } from 'react';
import { login } from '../api/auth';

export default function LoginPage({ onLogin, onForgot, onRegister }) {
  const [email, setEmail]       = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading]   = useState(false);
  const [error, setError]       = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email || !password) { setError('メールアドレスとパスワードを入力してください'); return; }
    setLoading(true);
    setError('');
    try {
      const data = await login(email, password);
      if (data.requires_2fa) {
        onLogin(data);
      } else {
        // 認証 token は HttpOnly Cookie でサーバーがセット済み
        onLogin(null);
      }
    } catch (err) {
      setError(err.response?.data?.detail ?? 'ログインに失敗しました');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #FF6B9D 0%, #9B5FE3 60%, #7048D4 100%)',
      padding: '16px',
    }}>
      <div style={{
        background: '#fff',
        borderRadius: 24,
        padding: 'clamp(28px, 8vw, 48px) clamp(20px, 6vw, 40px)',
        width: '100%',
        maxWidth: 380,
        boxShadow: '0 20px 60px rgba(0,0,0,0.18)',
      }}>
        <div style={{ textAlign: 'center', marginBottom: 32 }}>
          <div style={{ fontSize: 48, lineHeight: 1, marginBottom: 10 }}>📸</div>
          <div style={{
            fontFamily: "'Nunito', 'M PLUS Rounded 1c', sans-serif",
            fontSize: 26, fontWeight: 900, color: '#7048D4',
          }}>
            えがおフォルダ
          </div>
          <div style={{ fontSize: 13, color: '#888', marginTop: 6 }}>
            ログインしてください
          </div>
        </div>

        <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
          <div className="form-group">
            <label className="form-label">メールアドレス</label>
            <input
              className="form-input"
              type="email"
              autoComplete="email"
              placeholder="example@email.com"
              value={email}
              onChange={e => setEmail(e.target.value)}
            />
          </div>

          <div className="form-group">
            <label className="form-label">パスワード</label>
            <input
              className="form-input"
              type="password"
              autoComplete="current-password"
              placeholder="••••••••"
              value={password}
              onChange={e => setPassword(e.target.value)}
            />
          </div>

          {error && <div className="msg msg-error">{error}</div>}

          <button
            type="submit"
            className="btn btn-primary"
            disabled={loading}
            style={{ width: '100%', padding: '12px', marginTop: 8 }}
          >
            {loading ? <><span className="spinner" />ログイン中…</> : 'ログイン'}
          </button>

          <button
            type="button"
            onClick={onForgot}
            style={{
              background: 'none', border: 'none', cursor: 'pointer',
              color: '#9B5FE3', fontSize: 13, textAlign: 'center',
              width: '100%', marginTop: 4, textDecoration: 'underline',
            }}
          >
            パスワードをお忘れですか？
          </button>

          <div style={{ borderTop: '1px solid #eee', marginTop: 8, paddingTop: 12, textAlign: 'center' }}>
            <span style={{ fontSize: 12, color: '#888' }}>アカウントをお持ちでない方は</span>
            <button
              type="button"
              onClick={onRegister}
              style={{
                background: 'none', border: 'none', cursor: 'pointer',
                color: '#9B5FE3', fontSize: 13, marginLeft: 4,
                textDecoration: 'underline', fontWeight: 700,
              }}
            >
              新規登録
            </button>
          </div>

          {/* 法的リンク */}
          <div style={{ marginTop: 16, textAlign: 'center', fontSize: 11, color: '#aaa' }}>
            <a href="/terms" style={{ color: '#aaa', textDecoration: 'underline', marginRight: 12 }}>利用規約</a>
            <a href="/privacy" style={{ color: '#aaa', textDecoration: 'underline' }}>プライバシーポリシー</a>
          </div>
        </form>
      </div>
    </div>
  );
}
